import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface deposit {
    coinId: string,
    coinWallet: string,
    walletAddress: string,
    networkId: string,
    coinOfNetworkId:string,
    coinName: string,
    coinSymbol: string,

}
const initialState: deposit = {
    coinId: '',
    coinWallet: '',
    walletAddress: '',
    networkId: '',
    coinOfNetworkId:'',
     coinName: '',
    coinSymbol: '',


};
export const deposit = createSlice({
    name: "deposit",
    initialState,
    reducers: {
        coinInfo: (state, action: PayloadAction<{
            coinId:string,coinName:string,coinSymbol:string
        }>) => {

            state.coinId = action.payload.coinId
            state.coinName = action.payload.coinName
            state.coinSymbol = action.payload.coinSymbol

        },
        updateCoinWalletStatus: (state, action: PayloadAction<{
            status: string,
            walletAddress: string,
            networkId: string,
        }>) => {
            // console.log('updateCoinWalletStatus', action.payload.status)
            state.coinWallet = action.payload.status
            state.walletAddress = action.payload.walletAddress
            state.networkId = action.payload.networkId
        },
        updateCoinOfNetwrokId:(state,action:PayloadAction<string>)=>{
            state.coinOfNetworkId=action.payload
        }

    },
});
export const { coinInfo, updateCoinWalletStatus,updateCoinOfNetwrokId } = deposit.actions;

export default deposit.reducer;
